import { useEnabledSmartApplyPartners } from '@percent/cause-dashboard/common/hooks/useEnabledSmartApplyPartners/useEnabledSmartApplyPartners'
import type { SmartApplyPartner } from '@percent/cause-dashboard/constants/smartApplyPartnerConfig'

export const MAX_PARTNER_LOGOS = 5

export type PartnerLogo = {
  partner: SmartApplyPartner
  logo: string
}

export function useSmartApplyPartnerLogos(): PartnerLogo[] {
  const { enabledPartners, getConfig } = useEnabledSmartApplyPartners()

  return enabledPartners
    .map(partner => ({ partner, logo: getConfig(partner).logo }))
    .sort((a, b) => a.partner.localeCompare(b.partner))
    .slice(0, MAX_PARTNER_LOGOS)
}
